import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Form } from '../../../shared/models/form-builder/form.model';
import { SiteHomePage } from '../../../shared/models/form-builder/site-home-page.model';
import { FormField } from '../../../shared/models/form-builder/form-field.model';
import { FormInstance } from '../../../shared/models/site-content/form-instance.model';
import { FormInstanceElement } from '../../../shared/models/form-builder/form-instance-element.model';
import { CurrentSiteService } from '../../../shared/services/current-site.service';
import { FormInstanceService } from '../../../shared/services/form-instance.service';
import { SiteHomePageService } from '../../../shared/services/site-home-page.service';
import { FieldDefinitionService } from '../../../shared/services/field-definition.service';
import { FieldDefinition } from '../../../shared/models/form-builder/field-definition.model';
import { HomePageActionDialog, HomePageActionDialogInitData } from '../../../shared/dialogs/home-page-action/home-page-action.dialog';
import { HomePageActionDialogReturnObj, HomePageActionsEnum } from '../../../shared/dialogs/home-page-action/extras';
import { EventSubscription } from '../../../shared/models/event-subscription.model';
import { EventSubscriptionService } from '../../../shared/services/event-subscription.service'
import { SubscriptionFilter } from '../../../shared/models/notifications/subscription-filter.model';
import { DocumentPublishingService } from '../../../shared/services/document-publishing.service';
import { DocumentPublishingPickerDialog } from '../../../shared/dialogs/document-publishing/document-publishing-picker.dialog';

@Component({
    selector: 'app-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HomePageComponent implements OnInit {

    private homePageForm: SiteHomePage = null;
    private homePageDummyFormInstance: FormInstance = null;
    private newFormInstance: FormInstance;
    private showEditButton: boolean;

    constructor(
        private currentSiteService: CurrentSiteService,
        private siteHomePageService: SiteHomePageService,
        private formInstanceService: FormInstanceService,
        private fieldDefinitionService: FieldDefinitionService,
        private eventSubscriptionService: EventSubscriptionService,
        private readonly titleService: Title,
        private route: ActivatedRoute,
        private router: Router,
        private dialog: MatDialog,
        private documentPublishingService: DocumentPublishingService) { }

    ngOnInit(): void {
        this.siteHomePageService.get(this.currentSiteService.Site.id).then(response => {
            this.homePageForm = response;
            this.showEditButton = this.homePageForm.currentUserCanBuildForms || this.currentSiteService.Site.currentUserCanEditSiteHomePageHtml;

            // we only need this to fulfill certain expectations of FormRendererComponent
            // A FormInstance is not actually needed to render the home page because the types of fields
            // you can have on a home page (HTML and FormTemplateInstance) provide their own data 
            this.homePageDummyFormInstance = HomePageComponent.createSiteHomePageDummyFormInstance(this.fieldDefinitionService, this.homePageForm);
        });
        this.titleService.setTitle(this.route.snapshot.data['title'] + ' for ' + this.currentSiteService.Site.name);
    }

    public get HomePageForm() {
        return this.homePageForm;
    }

    public get NewFormInstance() {
        return this.newFormInstance;
    }

    public get FormInstanceService() {
        return this.formInstanceService;
    }

    public get HomePageDummyFormInstance() {
        return this.homePageDummyFormInstance;
    }

    public closeNewFormInstance(event: FormInstance) {
        console.log('closeNewFormInstance');
        console.log(event);
        this.newFormInstance = null;
    }

    public displayNewFormInstance(event: FormInstance) {
        console.log('HomePage.displayNewFormInstance()');
        console.log(event);

        let url = '/site/' + event.dataCollectionId + '/structure/folder/' + event.folderId + '/form/' + event.id;
        this.router.navigateByUrl(url);
    }

    public handleNameChange(event: FormInstance) {
        this.newFormInstance.rowVersion = event.rowVersion;
    }

    public get EditHomePageCaption(): string {
        if (!this.homePageForm.currentUserCanBuildForms && this.currentSiteService.Site.currentUserCanEditSiteHomePageHtml) {
            return "Edit Home Page HTML"
        }

        return "Edit Home Page"
    }

    public editButtonIsViewable(): boolean {
        return this.showEditButton;
    }

    public editHomePageClicked(): void {
        let relativeUrl: string = '';

        if (!this.homePageForm.currentUserCanBuildForms && this.currentSiteService.Site.currentUserCanEditSiteHomePageHtml) {
            relativeUrl = this.router.url.replace('/home-page', '/design-homepage-html');
        }
        else {
            relativeUrl = this.router.url.replace('/home-page', '/design-homepage');
        }

        this.router.navigateByUrl(relativeUrl).then(result => { });
    }

    public publishFolderClicked(): void {
        let data: HomePageActionDialogInitData = {
            siteId: this.currentSiteService.Site.id,
            siteName: this.currentSiteService.Site.name,
            selectedRows: [],//this.SelectedRows,
            action: "publishfolder",
            formId: 0 //this.formField.formTemplateId
        };
        let dialogRef = this.dialog.open(HomePageActionDialog, {
            width: '800px',
            data: data
        });

        dialogRef.afterClosed().subscribe(result => {
            // Get document publishing information.
            this.documentPublishingService.getDocumentPublishingSettingsForSite(this.currentSiteService.Site.id, true).then(x => {
                // Display the publishing dialogue.
                let dialogRef = this.dialog.open(DocumentPublishingPickerDialog, {
                    width: '800px',
                    data: {
                        settings: x,
                        entityType: 'folder',
                        entityId: result.folderToPublish
                    }
                });
            });
        });
    }

    public subscribeToFolderClicked(): void {
        let data: HomePageActionDialogInitData = {
            siteId: this.currentSiteService.Site.id,
            siteName: this.currentSiteService.Site.name,
            selectedRows: [],
            action: HomePageActionsEnum.ACTION_SUBSCRIBE_FOLDER,
            formId: 0
        };
        let dialogRef = this.dialog.open(HomePageActionDialog, {
            width: '800px',
            data: data
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result.subscribeFolderId) {
                let filter = new SubscriptionFilter('AncestorFolderFilter');
                filter.folderId = result.subscribeFolderId;

                let folderSubscription = new EventSubscription();
                folderSubscription.eventName = 'FormInstance_Added_To_Folder';
                folderSubscription.dataCollectionId = this.currentSiteService.Site.id;
                folderSubscription.filters = [];
                folderSubscription.filters.push(filter);
                folderSubscription.folderId = result.subscribeFolderId;

                this.eventSubscriptionService.subscribe([folderSubscription]);
            }
        });
    }

    // Helper methods.
    private static createSiteHomePageDummyFormInstance(fieldDefinitionService: FieldDefinitionService, homePageForm: Form): FormInstance {
        let dummyFormInstance = new FormInstance();
        dummyFormInstance.form = homePageForm; // Need when calling the server's FieldConditionalLogicService.OnSourceFieldValueChange().
        dummyFormInstance.canEdit = true; // Otherwise, the form renderer will mark all firelds as read-only.

        // Need to create form instance elements now that we are using radio button-based field conditional logic on site home pages.
        dummyFormInstance.formInstanceElements = [];
        if (homePageForm.formFields != null) {
            for (let index: number = 0; index < homePageForm.formFields.length; index++) {
                let formField: FormField = homePageForm.formFields[index];
                let fieldDef: FieldDefinition = fieldDefinitionService.getFieldDefinition(formField.fieldDefinitionClassName);
                let formInstanceElement: FormInstanceElement = fieldDef.customLogicHandler.createSiteHomePageFormInstanceElementFor(formField);
                dummyFormInstance.formInstanceElements.push(formInstanceElement);
            }
        }

        return dummyFormInstance;
    }
}
